<template>
    <div class="trip-choice">
        <div
            v-if="!isMobile"
            class="trip-choice__breadcrumbs">
            <Breadcrumbs
              :items="breadcrumbs"
            />
        </div>
        <div class="trip-choice__header">
            <div class="trip-choice__header-user-block">
                <div class="trip-choice__header-poster-img"></div>
                <div class="trip-choice__header-user-greeting">
                    Здравствуйте,<br> {{ user.name }}
                    <div class="trip-choice__pdf-wrapper">
                        <a
                            class="trip-choice__pdf-description"
                            target="_blank"
                            href="https://rsv-testing.hb.bizmrg.com/files/rs6tzqis/%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BA%D0%B0%20%D1%83%D1%87%D0%B0%D1%81%D1%82%D0%BD%D0%B8%D0%BA%D0%B0.pdf"
                        >
                            Памятка участника
                        </a>
                        <a
                            class="trip-choice__pdf-description"
                            target="_blank"
                            :href="getActPdfLink"
                        >
                            Положение о проекте
                        </a>
                    </div>
                </div>
            </div>
            <div class="trip-choice__header-poster-bg"></div>
        </div>
        <div class="trip-choice__content">
            <p class="trip-choice__content-header">
                АНО «Россия - страна возможностей» рада сообщить о том, что в качестве поощрения за активное участие 
                в конкурсах и проектах АНО «Россия - страна возможностей», платформы «Другое дело» и Российского общества «Знание» Вы можете стать обладателем поощрительной туристической поездки и отправиться
                в путешествие по России бесплатно.
            </p>
            <p class="trip-choice__content-title">Выбрать поездку</p>
            <div class="trip-choice__trip-preview">
                <img
                    src="~@/assets/images/account-track/trip-choice__trip-preview-image.png"
                    class="trip-choice__trip-preview-image"
                >
                <div class="trip-choice__counter-block">
                    <p class="trip-choice__counter-title">
                        До окончания действия предложения осталось
                    </p>
                    <TrackTripCounter
                        :expiration="getTripStatus.expiration"
                        bordered
                        column-mode
                        class="trip-choice__counter"
                    />
                    <div class="trip-choice__buttons-wrapper">
                        <a
                            class="trip-choice__counter-link"
                            :href="`https://morethantrip.ru/`"
                        >
                            Подробнее
                        </a>
                        <btn
                            class="trip-choice__refuse-btn"
                            outline
                            @click="showPopup = !showPopup"
                        >
                            {{ refuseBtnText }}
                        </btn>
                    </div>
                </div>
            </div>
            <TrackTripForm/>
        </div>
        <transition name="fade">
            <RefusePopup
                v-if="showPopup"
                @fadePopup="refusePopup"
            />
        </transition>
    </div>
</template>

<script>
import Breadcrumbs from '@/components/UI/Breadcrumbs';
import TrackTripCounter from '@/components/account/tabs/tab-track/components/TrackTripCounter';
import TrackTripForm from '@/components/account/tabs/tab-track/components/TrackTripForm';
import RefusePopup from '@/components/account/tabs/tab-track/components/RefusePopup';

import Btn from '@/components/UI/Button';
import { mapActions, mapGetters } from 'vuex';

const actions = [
    'loadStateStatus',
    'refuseTrip',
];

const getters = [
    'isMobile',
    'user',
    'getTripStatus',
    'getActPdfLink',
];

export default {
    name: 'TripChoice',
    data: () => ({
        breadcrumbs: [
            { text: 'Главная', path: { name: 'portal-main' } },
            { text: 'Личный кабинет', path: { name: 'account' } },
            { text: 'Выбрать поездку' },
        ],
        showPopup: false,
    }),
    components: {
        Breadcrumbs,
        TrackTripCounter,
        TrackTripForm,
        Btn,
        RefusePopup,
    },
    computed: {
        ...mapGetters(getters),
        refuseBtnText () {
            return this.isMobile ? 'Отказаться' : 'Отказаться от поездки';
        },
    },
    methods: {
        ...mapActions(actions),
        refusePopup(val) {
            this.showPopup = val;
        },
    },
    async created() {
        const statusIds = [2];

        await this.loadStateStatus();

        if( statusIds.indexOf(this.getTripStatus.state) == -1 ) {
            this.$router.push({ name: '404' });
        };
    },
};
</script>

<style lang="scss" scoped>
    @import '@/styles/rem';
    @import '@/styles/mrem';

    $bg: #713DD3;
    $greenFontcolor: #02BF89;

    .trip-choice {
        margin-top: mrem(26);
        @include on-desktop {
            width: 80rem;
            min-height: 100vh;
            margin: 0 auto rem(32) auto;
        }

        &__refuse-btn {
            color: #131614;
            border: 1px solid #131614;
            padding: mrem(10) mrem(25);

            @include on-desktop {
                margin-left: rem(25);
                padding: rem(10) rem(15);
            }
        }

        &__buttons-wrapper{
            display: flex;
            justify-content: space-between;

            @include on-desktop {
                justify-content: start;
            }
        }

        &__pdf-wrapper {
            display: flex;
            justify-content: space-between;
            position: absolute;
            top: mrem(25);
            width: mrem(320);
            margin-left: mrem(30);
            @include on-desktop {
               top: rem(190);
               margin-left: rem(30);
               width: rem(310);
            }
        }

        &__pdf-description {
            font-size: mrem(16);
            line-height: mrem(20);
            font-weight: normal;
            text-align: center;
            color: #fff;
            border-bottom: 1px solid #fff;
            @include on-desktop {
                font-size: rem(15);
                line-height: rem(20);
            }
        }

        &__header {
            position: relative;
            height: mrem(120);
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            @include on-desktop {
                height: rem(235);
                background: $bg;
            }
        }

        &__header-user-block {
            @include on-desktop {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 50%;
                padding: rem(28) rem(38);
            }
        }

        &__header-poster-img {
            width: mrem(110);
            height: mrem(97);
            margin-left: mrem(24);
            background: #fff url("~@/assets/images/account-track/track-trip__poster.svg") no-repeat center;
            background-size: cover;
            @include on-desktop {
                width: rem(216);
                height: rem(190);
                margin-left: 0;
            }
        }

        &__header-poster-bg {
            width: mrem(224);
            height: mrem(124);
            background: url("~@/assets/images/account-track/track-trip__bg_mobile.svg") no-repeat right;
            background-size: contain;
            @include on-desktop {
                width: 50%;
                height: rem(235);
                background: url("~@/assets/images/account-track/track-trip__bg.svg") space;
            }
        }

        &__header-user-greeting {
            position: absolute;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: mrem(54);
            bottom: mrem(-54);
            margin: 0;
            font-weight: 600;
            font-size: mrem(18);
            line-height: mrem(22);
            text-align: center;
            color: #fff;
            background: $bg;
            br {
                display: none;
            }
            @include on-desktop {
                position: static;
                width: rem(366);
                height: rem(118);
                font-size: rem(48);
                line-height: rem(59);
                br {
                    display: inline-block;
                }
            }
        }

        &__content {
            margin-top: mrem(72);
            padding: mrem(16);
            background: #fff;
            @include on-desktop {
                margin-top: 0;
                padding: rem(80) rem(221) rem(120) rem(120);
                border-left: rem(3) solid $bg;
            }
        }

        &__content-header {
            font-size: mrem(16);
            line-height: mrem(26);
            margin: 0 0 mrem(20) 0;
            @include on-desktop {
                font-size: rem(21);
                line-height: rem(30);
                margin-bottom: rem(40);
            }
        }

        &__content-title {
            font-weight: 600;
            font-size: mrem(24);
            line-height: mrem(40);
            @include on-desktop {
                font-size: rem(32);
                line-height: rem(40);
            }
        }

        &__trip-preview {
            display: flex;
            flex-direction: column;
            margin-bottom: mrem(30);
            @include on-desktop {
                flex-direction: row;
                justify-content: space-between;
                font-size: rem(32);
                line-height: rem(40);
                margin-bottom: rem(30);
            }
        }

        &__trip-preview-image {
            width: 100%;
            @include on-desktop {
                width: rem(571);
                height: rem(248);
            }
        }

        &__counter-block {
            @include on-desktop {
                width: rem(609);
            }
        }

        &__counter-title {
            font-weight: bold;
            font-size: mrem(18);
            line-height: mrem(30);
            text-transform: uppercase;
            margin-bottom: mrem(16);
            color: $bg;
            @include on-desktop {
                font-size: rem(24);
                line-height: rem(36);
                margin: 0 0 rem(12) 0;
            }
        }

        &__counter {
            width: 100%;
            margin-bottom: mrem(16);
            @include on-desktop {
                margin-bottom: rem(33);
            }
        }

        &__counter-link {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: mrem(12) mrem(24);
            background: #02BF89;
            color: #fff;
            border-radius: 4px;
            font-size: mrem(18);
            font-weight: bold;
            line-height: mrem(26);
            width: mrem(144);
            @include on-desktop {
                width: rem(144);
                font-size: rem(18);
                line-height: rem(26);
                padding: rem(12) rem(24);
            }
        }

        &__attention-block {
            margin-bottom: mrem(30);
            @include on-desktop {
                margin-bottom: rem(30);
            }
        }

        &__attention-title {
            font-weight: bold;
            font-size: mrem(18);
            line-height: mrem(30);
            text-transform: uppercase;
            margin-bottom: mrem(2);
            color: $bg;
            @include on-desktop {
                font-size: rem(24);
                line-height: rem(36);
                margin: 0 0 rem(12) 0;
            }
        }

        &__attention-bold {
            font-weight: bold;
            font-size: mrem(18);
            line-height: mrem(30);
            text-transform: uppercase;
            @include on-desktop {
                font-size: rem(24);
                line-height: rem(36);
            }
        }

        &__attention-text {
            font-size: mrem(16);
            line-height: mrem(26);
            margin: 0 0 mrem(12) 0;
            @include on-desktop {
                font-size: rem(24);
                line-height: rem(36);
                margin: 0 0 rem(20) 0;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
